import Colors from 'enums/Colors';
import styled from 'styled-components';

const FVPackageStyled = {
    Container: styled.div`
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 16px;
    `,

    RowBettween: styled.div`
        display: flex;
        justify-content: space-between;
        align-items: center;
    `,

    Button: styled.button`
        background: linear-gradient(90deg, #ffb300 0%, #ffcb3a 100%);
        color: #003c78;
        font-weight: bold;
        font-size: 1.1rem;
        border: none;
        border-radius: 6px;
        padding: 12px 0;
        margin-top: 12px;
        cursor: pointer;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.08);
        transition: background 0.2s, color 0.2s;
        text-transform: uppercase;
        max-width: 260px;
        &:hover {
            background: linear-gradient(90deg, #ffcb3a 0%, #ffb300 100%);
            color: #00264d;
        }
    `,

    Card: {
        Container: styled.div`
            display: flex;
            border-radius: 12px;
            width: fit-content;
            height: 380px;
            box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
            transition: all 0.3s ease;
            cursor: pointer;
            z-index: 2;

            &:hover {
                transform: translateY(-4px);
                box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);

                .hoverCardPackage {
                    background: ${Colors.Yellow};
                }
            }

            img {
                height: 140px;
                width: 100%;
                object-fit: contain;
            }

            h1 {
                color: ${Colors.Blue};
                font-size: 26px;
                font-weight: 700;
            }

            p {
                color: ${Colors.BlueGrey};
                font-size: 16px;
                font-weight: 400;
                line-height: 18px;
                max-width: 100%;
            }
        `,

        Content: styled.div<{ width: string; color?: string; background?: string; img?: string; radius?: string }>`
            width: ${props => props.width};
            display: flex;
            align-items: center;
            justify-content: center;
            color: ${props => props.color || Colors.Blue};
            background: ${props => props.background || 'transparent'};
            background-image: url(${props => props.img});
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            border-radius: ${props => props.radius || '0px'};
            transition: all 0.3s ease;

            h1 {
                font-size: 110px;
            }
        `,

        Information: {
            Container: styled.div`
                display: flex;
                flex-direction: column;
                gap: 16px;
                max-width: 600px;
            `,

            Title: styled.h2<{ hovered?: boolean }>`
                font-size: 32px;
                font-weight: 700;
                line-height: 40px;
                text-transform: uppercase;
                color: ${({ hovered }) => (hovered ? Colors.Yellow : Colors.White)};
            `,
            Description: styled.p`
                font-family: 'Barlow';
                font-weight: 500;
                font-style: Medium;
                font-size: 24px;
                line-height: 150%;
                letter-spacing: -1%;
                vertical-align: middle;

                color: ${Colors.White};
            `,
        },
    },

    Page: {
        Container: styled.div`
            display: flex;
            flex-direction: column;
            gap: 2rem;
        `,

        Column: styled.div`
            flex: flex;
            flex-direction: column;
            width: 500px;
            padding: 16px;
        `,

        Row: styled.div`
            display: flex;
            flex-direction: row;
            gap: 16px;
        `,

        SubTitle: styled.h2`
            font-family: 'Barlow';
            font-weight: 700;
            font-style: Bold;
            font-size: 32px;
            line-height: 150%;
            letter-spacing: -1%;
            vertical-align: middle;
            text-transform: uppercase;
            color: ${Colors.White};
        `,

        Title: styled.h1`
            font-family: 'Barlow';
            font-weight: 700;
            font-style: Bold;
            font-size: 40px;
            line-height: 150%;
            letter-spacing: -1%;
            vertical-align: middle;
            text-transform: uppercase;
            color: ${Colors.Yellow};
        `,

        Description: styled.p`
            font-family: 'Barlow';
            font-weight: 500;
            font-style: Medium;
            font-size: 24px;
            line-height: 150%;
            letter-spacing: -1%;
            vertical-align: middle;
            color: ${Colors.White};
            margin-top: 32px;
        `,

        Card: {
            Container: styled.div`
                display: flex;
                width: 744px;
                height: 380px;
                border-radius: 24px;
                overflow: hidden;
            `,

            Content: styled.div<{ img?: string; backcolor?: string }>`
                width: 50%;
                background-image: url(${props => props.img});
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
                background-color: ${props => props.backcolor};
                color: ${Colors.Blue};
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                h2 {
                    font-family: 'Barlow';
                    font-weight: 700;
                    font-style: Bold;
                    font-size: 48px;
                    line-height: 150%;
                    letter-spacing: -1%;
                    vertical-align: middle;
                    text-transform: uppercase;
                }

                h1 {
                    font-family: 'Barlow';
                    font-weight: 700;
                    font-style: Bold;
                    font-size: 149.84px;
                    line-height: 150%;
                    letter-spacing: -1%;
                    text-align: center;
                    vertical-align: middle;
                }
            `,
        },

        ContentGrid: styled.div`
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
        `,
    },
};

export default FVPackageStyled;
